module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "zn1k3bcu",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
    token: process.env.GATSBY_SANITY_READ_TOKEN,
  },
}
